import React from 'react';
import Badge from 'react-bootstrap/Badge';
import { Card } from 'react-bootstrap';
import './Projects.css';
import Particle from '../Particle';
import iop from '../../Assets/IOP.png';
import YouTubeMobile from '../../Assets/YoutubeMobile.png';
import rtr from '../../Assets/rtr.png';
import VmsDesignImg from './ui/vmsImg';
import BBDesignImg from './ui/bbImg';
import APDesignImg from './ui/apImg';
import MyProjectsDesignImg from './ui/myprojects';
import MyWeatheAppImg from '../../Assets/WeatherApp.png';
import MyCalculator from '../../Assets/myCalculator.png';
import MyMovieGPT from '../../Assets/MovieGPTHome.png';

const projectcards = {
  list: [
    {
      title: 'Integrated Operations Platform',
      img_path: 'iop',
      description:
        'Worked as a Key UI developer for this product. This product was delivered to an Oil and Gas Company. An intuitive application which would unify information and integrate business operations.',
      tags: [
        {
          lang: 'SAPUI5',
          color: 'blue',
        },
        {
          lang: 'SAP Fiori',
          color: 'basicBlue',
        },
        {
          lang: 'Java',
          color: 'purple',
        },
        {
          lang: 'SAP Cloud Platform',
          color: 'basicBlue',
        },
        {
          lang: 'MySQL',
          color: 'red',
        },
      ],
      link: '',
      code: '',
      linkcolor: 'white',
    },
    {
      title: 'Real-Time Reaction',
      img_path: 'rtr',
      description:
        'Worked as a Key UI developer for Real-Time Reaction product, which is a disruptive solution for Murphy oil and gas Corporation. This product has a high-value use case for the Drilling and Completion business unit.',
      tags: [
        {
          lang: 'SAPUI5',
          color: 'basicBlue',
        },
        {
          lang: 'PlotlyJs',
          color: 'red',
        },
        {
          lang: 'Java',
          color: 'purple',
        },
        {
          lang: 'SAP Cloud Platform',
          color: 'Blue',
        },
        {
          lang: 'MySQL',
          color: 'basicBlue',
        },
        {
          lang: 'Canary',
          color: 'green',
        },
      ],
      link: '',
      code: '',
      linkcolor: 'white',
    },
    {
      title: 'Visitor Management System',
      img_path: 'vms',
      description:
        'Visitor management system provides an intelligent and effective way to manage the visitors coming to an organization. Facilities like creation of meeting, sending email confirmation, check-in, checkout real-time notifications, and a lot more are available',
      tags: [
        {
          lang: 'SAP UI5',
          color: 'basicBlue',
        },
        {
          lang: 'JavaScript',
          color: 'yellow',
        },
        {
          lang: 'SAP Cloud',
          color: 'blue',
        },
        {
          lang: 'Java',
          color: 'purple',
        },
        {
          lang: 'MySQL',
          color: 'basicBlue',
        },
      ],
      link: 'https://github.com/sumanthn3/NEO_VMS.git',
      code: 'https://github.com/sumanthn3/NEO_VMS.git',
      linkcolor: 'white',
    },
    {
      title: 'Movie GPT',
      img_path: 'moviegpt',
      description:
        'Movie GPT Platform is a cutting-edge web application that offers users a personalized and secure movie browsing experience. With intuitive navigation, robust authentication, and real-time TMDB integration, the platform delivers a responsive and engaging interface enriched by Tailwind CSS. ',
      tags: [
        {
          lang: 'React',
          color: 'Blue',
        },
        {
          lang: 'JavaScript',
          color: 'yellow',
        },
        {
          lang: 'Redux',
          color: 'red',
        },
        {
          lang: 'CSS',
          color: 'skyBlue',
        },
        {
          lang: 'ChatGPT',
          color: 'green',
        },
        {
          lang: 'TMDB API',
          color: 'purple',
        },
        {
          lang: 'FireBase',
          color: 'basicBlue',
        },
      ],
      link: 'https://snmoviegpt.netlify.app/',
      code: 'https://github.com/sumanthn3/my-moviegpt.git',
      linkcolor: 'white',
    },
    {
      title: 'Weather Wise',
      img_path: 'weather',
      description:
        'WeatherWise is an innovative and user-friendly responsive web application designed to provide users with up-to-date weather information tailored to their current location. With a seamless and intuitive interface.',
      tags: [
        {
          lang: 'React',
          color: 'Blue',
        },
        {
          lang: 'JavaScript',
          color: 'yellow',
        },
        {
          lang: 'Redux',
          color: 'red',
        },
        {
          lang: 'CSS',
          color: 'skyBlue',
        },
      ],
      link: 'https://snliveweather.netlify.app/',
      code: 'https://github.com/sumanthn3/my-weatherapp.git',
      linkcolor: 'white',
    },
    {
      title: 'YouTube Clone Project',
      img_path: 'youtube',
      description:
        'This is a responsive YouTube website clone using React JS and Tailwind CSS. This project mirrors the official YouTube platform, offering seamless video search and playback functionalities.',
      tags: [
        {
          lang: 'React',
          color: 'Blue',
        },
        {
          lang: 'NodeJs',
          color: 'lightred',
        },
        {
          lang: 'Redux',
          color: 'red',
        },
        {
          lang: 'TailwindCSS',
          color: 'skyBlue',
        },
      ],
      link: 'https://snutube.netlify.app/',
      code: 'https://github.com/sumanthn3/my-youtube.git',
      linkcolor: 'white',
    },

    {
      title: 'Budget Boss',
      img_path: 'bb',
      description:
        'The vision for a Budget Boss Mobile app is to help users effectively manage their day-to-day expenses including Loans, Subscriptions, Insurance by providing them with tools to track their balances, payments, interest rates, and due dates.',
      tags: [
        {
          lang: 'Angular',
          color: 'red',
        },
        {
          lang: 'Ionic',
          color: 'orange',
        },
        {
          lang: 'Java',
          color: 'purple',
        },
        {
          lang: 'MySql',
          color: 'basicBlue',
        },
        {
          lang: 'AWS EC2',
          color: 'orange',
        },
      ],
      link: 'https://github.com/sblsatwikha/OODProject',
      code: 'https://github.com/sblsatwikha/OODProject',
      linkcolor: 'white',
    },
    {
      title: 'Calculator',
      img_path: 'calculator',
      description:
        'This is a simple calculator web application built using React. It allows users to perform basic arithmetic calculations like addition, subtraction, multiplication, and division. The calculator provides a user-friendly interface to input numbers and operators and displays the result of the calculation.',
      tags: [
        {
          lang: 'React',
          color: 'Blue',
        },
        {
          lang: 'JavaScript',
          color: 'yellow',
        },
        {
          lang: 'Redux',
          color: 'red',
        },
        {
          lang: 'CSS',
          color: 'skyBlue',
        },
      ],
      link: 'https://sncalculator.netlify.app/',
      code: 'https://github.com/sumanthn3/my-calculator.git',
      linkcolor: 'white',
    },
    {
      title: 'Admission Portal',
      img_path: 'ap',
      description:
        'This application helps with the Admission of a student. Features like seat allotment, regulation and curriculum creation, time tables, marks creation, and a lot more...',
      tags: [
        {
          lang: 'Angular',
          color: 'red',
        },
        {
          lang: 'NodeJs',
          color: 'lightred',
        },
      ],
      link: '',
      code: '',
      linkcolor: 'white',
    },
  ],
};
function GetSkillSvg(props) {
  if (props.fileName === 'iop') return <Card.Img variant="top" src={iop} />;
  else if (props.fileName === 'vms') return <VmsDesignImg />;
  else if (props.fileName === 'rtr')
    return <Card.Img variant="top" className="ImageTop" src={rtr} />;
  else if (props.fileName === 'bb') return <BBDesignImg />;
  else if (props.fileName === 'ap') return <APDesignImg />;
  else if (props.fileName === 'youtube')
    return <Card.Img variant="top" src={YouTubeMobile} />;
  else if (props.fileName === 'weather')
    return <Card.Img variant="top" src={MyWeatheAppImg} />;
  else if (props.fileName === 'moviegpt')
    return <Card.Img variant="top" src={MyMovieGPT} />;
  else if (props.fileName === 'calculator')
    return <Card.Img className="ImageTop" variant="top" src={MyCalculator} />;
}
function Projects() {
  return (
    <div className="projects-main">
      <Particle />
      <div className="basic-projects">
        <div className="projects-heading-div">
          <div className="projects-heading-img-div">
            <MyProjectsDesignImg />
          </div>
          <div className="projects-heading-text-div">
            <h1 className="projects-heading-text">My Projects</h1>
            {/* <p className="projects-header-detail-text subTitle">description</p> */}
          </div>
        </div>
      </div>
      <div className="repo-cards-div-main">
        {/* <CardColumns> */}
        {projectcards.list.map((proj) => {
          return (
            <Card className="h-100">
              <GetSkillSvg fileName={proj.img_path} />
              <Card.Body>
                <Card.Title>
                  <h3 style={{ lineHeight: '1.5', marginTop: '0' }}>
                    {proj.title}
                    {proj.link && (
                      <a
                        href={proj.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i
                          className="fas fa-external-link-alt"
                          style={{ color: proj.linkcolor, marginLeft: '10px' }}
                        ></i>
                      </a>
                    )}
                    {proj.code && (
                      <a
                        href={proj.code}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i
                          className="fab fa-github"
                          style={{ color: proj.linkcolor, paddingLeft: '10px' }}
                        ></i>
                      </a>
                    )}
                  </h3>
                </Card.Title>
                <div>
                  {proj.tags.map((demo2, index) => {
                    return (
                      <Badge
                        style={{
                          marginRight: '0.5em',
                          backgroundColor: demo2.color,
                        }}
                        className={`tag-badge tag-color-${demo2.color}`}
                      >
                        {' '}
                        {demo2.lang}
                      </Badge>
                    );
                  })}
                </div>
                <div
                  className="text-center"
                  style={{ marginTop: '20px' }}
                ></div>
                <Card.Text className="cardtext">{proj.description}</Card.Text>
              </Card.Body>
            </Card>
          );
        })}
        {/* </CardColumns> */}
      </div>
    </div>
  );
}

export default Projects;
